import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone, StrategicAxis } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  strategicAxes: Identifiable<StrategicAxis>[];
  retrieveStrategicAxes(
    request: Boundaries["retrieveStrategicAxes"]["request"],
  ): void;
}

function useRetrieveStrategicAxes(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveProjectPortfoliosRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveProjectPortfoliosRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveProjectPortfoliosRequestFailure,
    ),
    strategicAxes: useSelector(selector.getStrategicAxes),
    retrieveStrategicAxes: core.retrieveStrategicAxes,
  };
}

export { useRetrieveStrategicAxes };
